<template>
    <div class="landing-screen">
        
        <!-- Top hero section (teal arch background) -->
        <div class="landing-hero">
            <img src="/images/prubsn/layout/top.png" class="landing-top-img" alt="">
            <img src="/images/prubsn/lamp/lamp-1-1.png" class="landing-lamp-img landing-lamp-1-1" alt="">
            <img src="/images/prubsn/lamp/lamp-1-2.png" class="landing-lamp-img landing-lamp-1-2" alt="">
            <img src="/images/prubsn/lamp/lamp-2.png" class="landing-lamp-img landing-lamp-2" alt="">
            <img src="/images/prubsn/lamp/lamp-3.png" class="landing-lamp-img landing-lamp-3" alt="">
            
            <!-- Logo Bar -->
            <div class="landing-logo-bar">
                <img src="/images/prubsn/layout/logo.png" class="img-fluid landing-logo" alt="Prudential BSN Takaful">
            </div>

            <div class="landing-hero-content">
                <h1 class="landing-title">Selamat Hari Raya Aidilfitri</h1>
                <p class="landing-subtitle">Cipta Kad Raya Istimewa Untuk<br>Keluarga &amp; Rakan</p>
                <button class="btn landing-cta-btn w-100" @click="startDesignPostCard">Cipta Kad Raya Anda <ArrowRight :size="16" class="ms-1" /></button>
            </div>
        </div>
        
        <!-- Footer hero image + bottom bar overlap -->
        <div class="landing-footer-wrap">
            <img src="/images/prubsn/layout/footer.png" class="landing-footer-img" alt="Kaulah Hero Duniamu">
            <!-- Bottom bar -->
            <div class="landing-bottom-bar">
                <a href="https://www.prubsn.com.my/en/privacy-policy/" target="_blank" class="landing-privacy-link">Privacy Policy</a>
                <span class="landing-copyright">© Copyright Prudential BSN Takaful Berhad (200401010835)</span>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ArrowRight } from 'lucide-vue-next';

const emits = defineEmits(['continue'])

const startDesignPostCard = () => {
    emits('continue');
}
</script>

<style lang="scss">
.landing-screen {
    width: 100%;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    position: relative;
    overflow: hidden;

    @include media-breakpoint-up(md) {
        border-radius: 0.5rem;
    }
}

.landing-logo-bar {
    position: absolute;
    top:320px;
    left: 50%;
    transform: translateX(-50%);

    @include media-breakpoint-up(md) {
        position: absolute;
        top:55%;
        left: 50%;
        transform: translateX(-50%);
        z-index: 3;
        padding: 0;
        background-color: transparent;
    }

    @media (max-height: 860px) and (min-height: 800px) {
        position: absolute;
        top: 280px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 3;
        padding: 0;
        background-color: transparent;
    }

    @media (max-height: 770px) {
        position:absolute;
        top:280px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 3;
        padding: 0;
    }

    @media (max-height: 730px) {
        position:absolute;
        top:250px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 3;
        padding: 0;
    }
}

.landing-logo {
    position: relative;
    top: -80px;
    left: 0;
    right: 0;
    z-index: 2;
    width: 100%;
    max-width: 250px;

    @include media-breakpoint-up(md) {
        max-width: 340px;
        width: 100%;
    }

    @media (max-height: 730px) {
        max-width: 300px;
        width: 100%;
    }
}

.landing-hero {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;

    .landing-top-img {
        width: 100%;
        display: block;
    }

    .landing-lamp-img {
        position: absolute;
        top: 0;
        display: block;
        z-index: 2;
        pointer-events: none;
        transform-origin: top center;
        animation: lamp-sway 7s ease-in-out infinite;
    }

    .landing-lamp-1-1 {
        left: 0;
        transform: translateX(1%);
        width: 20%;
        animation-delay: 0s;
    }

    .landing-lamp-1-2 {
        left: 22%;
        transform: translateX(1%);
        width: 18%;
        animation-delay: 2.5s;
    }

    .landing-lamp-2 {
        left: 75%;
        transform: translateX(-5%);
        width: 30%;
        animation-delay: -1.5s;
        animation-name: lamp-sway-center;
    }

    .landing-lamp-3 {
        right: 0;
        width: 12%;
        animation-delay: -2.3s;
        animation-name: lamp-sway-right;
    }

    .landing-hero-content {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 1.5rem ;
        z-index: 3;
    }
}

.landing-title {
    font-family: 'Pattaya';
    font-size: 56px;
    font-weight: 400;
    background: linear-gradient(180deg, #62CED3, #00777F);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-align: center;
    line-height: 1.15;
    margin-bottom: 0.5rem;


    @include media-breakpoint-up(md) {
        font-size: 46px;
        padding-inline: 40px;
    }

    @media (max-height: 799px) {
        font-size: 46px;
        padding-inline: 20px;
    }

    @media (max-height: 730px) {
        font-size: 45px;
        padding-inline: 0;
    }
}

.landing-subtitle {
    font-size: 18px;
    font-weight: 700;
    background: linear-gradient(90deg, #A47020, #DDB56D);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-align: center;
    margin-bottom: 48px;
    line-height: 1.4;

    @include media-breakpoint-up(md) {
        font-size: 15px;
        margin-bottom: 20px;
    }

    @media (max-height: 799px) {
        font-size: 14px;
        margin-bottom: 1.25rem;
    }

    @media (max-height: 650px) {
        font-size: 10px;
        margin-bottom: 0.75rem;
    }
}

.landing-cta-btn {
    background-image: url('/images/svg/red-button.svg');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
    background-color: transparent;
    color: #ffffff;
    font-weight: 700;
    font-size: 20px;
    border: none;
    border-radius: 0;
    width: 100%;
    display: block;
    min-height: 66px;
    padding: 0.85rem 1rem;
    overflow: visible;
    position: relative;
    transition: filter .3s ease-in-out;
    margin-bottom: 15px;

    @include media-breakpoint-up(md) {
        font-size: 14px;
        min-height: 48px;
        padding: 0.6rem 1rem;
        width: 80%;
        align-self: center;
        margin-bottom: 0;
    }

    @media (max-height: 799px) {
        font-size: 12px;
        padding: 0.6rem 1rem;
        min-height: 50px;
    }

    @media (max-height: 730px) {
        margin-bottom: 0;
    }

    &:hover,
    &:focus {
        background-color: transparent;
        color: #ffffff;
        filter: brightness(0.88);
    }
}

@keyframes lamp-sway {
    0%   { transform: rotate(-2deg); }
    50%  { transform: rotate(2deg); }
    100% { transform: rotate(-2deg); }
}

@keyframes lamp-sway-center {
    0%   { transform: translateX(-50%) rotate(-3deg); }
    50%  { transform: translateX(-50%) rotate(3deg); }
    100% { transform: translateX(-50%) rotate(-3deg); }
}

@keyframes lamp-sway-right {
    0%   { transform: rotate(-3deg); }
    50%  { transform: rotate(3deg); }
    100% { transform: rotate(-3deg); }
}

.landing-footer-wrap {
    position: relative;
    width: 100%;
    line-height: 0;

    .landing-footer-img {
        width: 100%;
        display: block;
    }
}

.landing-bottom-bar {
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    z-index: 2;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 1rem;
    font-size: 0.65rem;
    color: #666666;
    flex-wrap: wrap;
    gap: 0.25rem;
}

.landing-privacy-link {
    color: #A5A5A5;
    text-decoration: underline;
    font-size: 10px;

    &:hover {
        text-decoration: underline;
    }
}

.landing-copyright {
    font-size: 10px;
    color: #A5A5A5;
}
</style>
